import { getDiffuseur } from '@/helpers/functions/diffuseur'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { NETWORKS_CAPTIONS } from '@/helpers/constantes/captionConstants'
import creerObjetCaption from '@/helpers/functions/captions'
import { Message } from 'element-ui'

export default {
  namespaced: true,
  state: {
    captions: [],
    message: null,
    isLoadingCaption: false
  },
  getters: {
    getCaptionByNetwork: (state) => (diffuseur, annonceId) => {
      let item = state.captions.find((caption) => caption.diffuseurNomDeCode === diffuseur && caption.annonceId === annonceId)
      if (item == null) {
        item = state.captions.push({ annonceId: annonceId, diffuseurNomDeCode: diffuseur, text: '' })
      }
      return item
    },
    getMessage: (state) => {
      return state.message
    },
    getIsLoadingCaption: (state) => state.isLoadingCaption
  },
  actions: {
    loadCaptions ({ state, commit, rootState }, { universe, annonceId, bienVendu }) {
      commit('setIsLoadingCaption', true)
      const captions = []
      const captionsEmpty = []
      // 1- Récupéré les captions existantes et créé l'objet pour les captions qui n'existe pas avec le texte vide
      HTTP_HYPER_ESPACE_BACKEND.get(`/annonce/${annonceId}`)
        .then(response => {
          const post = response.data
          const donnees = response.data.donnees

          for (const network in NETWORKS_CAPTIONS) {
            const diffuseur = getDiffuseur(network, universe, bienVendu)
            if (NETWORKS_CAPTIONS[network] in donnees) {
              const content = donnees[NETWORKS_CAPTIONS[network]].valeur
              const caption = creerObjetCaption(post.id, diffuseur, content)
              captions.push(caption)
            } else {
              const caption = creerObjetCaption(post.id, diffuseur)
              captions.push(caption)
              captionsEmpty.push(caption)
            }
          }

          // 2- Si j'ai que l'option IA, je génére les textes par IA (génére automatiquement sans validation User)
          // 3- Ou si on a flux
          const sitimmoUser = rootState.app.sitimmoUser
          const hasOptionIaOnly = sitimmoUser.optionIa && !sitimmoUser.personnalisationPrompts
          const hasFlux = !sitimmoUser.optionIa && !sitimmoUser.personnalisationPrompts
          if (hasOptionIaOnly || hasFlux) {
            for (const captionKey in captionsEmpty) {
              const diffuseurNomDeCode = captionsEmpty[captionKey].diffuseurNomDeCode
              const url = `/annonce-post?annonceId=${annonceId}&diffuseurNomDeCode=${diffuseurNomDeCode}`
              HTTP_HYPER_ESPACE_BACKEND.get(url).then(response => {
                commit('setCaptionsEmpty', response.data)
              }).catch(error => {
                console.log({ type: 'error', message: error })
              })
            }
          }

          commit('setCaptions', captions)
        }).catch(() => {
          Message.error('Erreur de chargement des données')
        }).finally(() => {
          commit('setIsLoadingCaption', false)
        })
    },
    updateCaption ({ state, commit }, { caption, login, post, emission, isNeedSocialNetwork }) {
      const newPost = {}
      const indexCaptionInStore = state.captions.findIndex((item) => item === caption)
      const nameCaptionNetwork = NETWORKS_CAPTIONS[caption.diffuseurNomDeCode.split('_')[0]]
      newPost[nameCaptionNetwork] = caption.text
      newPost.id = post.id

      const data = {
        annonceur: {
          login: login
        },
        flux: {
          code: emission.codeName,
          emissionId: emission.id
        },
        annonce: {
          [nameCaptionNetwork]: caption.text
        }
      }
      // Gestion donnée url vidéo
      data.annonce.post_video_file_url_custom = post.post_video_file_url_custom
      if (isNeedSocialNetwork) {
        data.source = { code: 'SOCIAL_NETWORK' }
      }
      commit('setIsLoadingCaption', true)
      HTTP_HYPER_ESPACE_BACKEND
        .patch(`/annonce/${post.id}`, data)
        .then(response => {
          commit('setCaptionOfNetwork', { indexCaptionInStore, caption })
          commit('setMessageCaptionUpdated', { type: 'success', message: 'Votre annonce a bien été mise à jour' })
        })
        .catch(error => {
          return { type: 'error', message: error }
        }).finally(() => {
          commit('setIsLoadingCaption', false)
        })
    },
    resetCaption ({ commit }, { network, universe, post, bienVendu }) {
      const annonceId = post.id
      const diffuseur = getDiffuseur(network, universe, bienVendu)
      const url = `/annonce-post?annonceId=${annonceId}&diffuseurNomDeCode=${diffuseur}`
      commit('setIsLoadingCaption', true)
      HTTP_HYPER_ESPACE_BACKEND.delete(url)
        .then((response) => {
          if (response.status === 200) {
            commit('deleteCaption', {
              diffuseur,
              annonceId
            })
            HTTP_HYPER_ESPACE_BACKEND.get(url)
              .then(response => {
                commit('setNewCaption', response.data)
              }).catch(error => {
                console.log({ type: 'error', message: error })
              }).finally(() => {
                commit('setIsLoadingCaption', false)
              })
          }
        }).catch(error => {
          return { type: 'error', message: error }
        })
    },
    loadCaptionsWithPromptLibrairies ({ state, commit }, { data, diffuseurName }) {
      const url = `/annonce-post?annonceId=${data.id}&diffuseurNomDeCode=${diffuseurName}`
      commit('setIsLoadingCaption', true)
      HTTP_HYPER_ESPACE_BACKEND.delete(url)
        .then(response => {
          if (response.status === 200) {
            const caption = { annonceId: data.id, diffuseurNomDeCode: diffuseurName }
            commit('deleteCaption', caption)
            HTTP_HYPER_ESPACE_BACKEND.get(url)
              .then((response) => {
                const indexCaption = state.captions.findIndex((caption) => caption.diffuseurNomDeCode === response.data.diffuseurNomDeCode)
                if (indexCaption > -1) {
                  commit('setCaptionOfNetwork', { index: indexCaption, caption: response.data })
                } else {
                  commit('setNewCaption', response.data)
                }
              }).catch(error => {
                console.log({ type: 'error', message: error })
              }).finally(() => {
                commit('setIsLoadingCaption', false)
              })
          }
        })
    }
  },
  mutations: {
    setIsLoadingCaption (state, bool) {
      state.isLoadingCaption = bool
    },
    setCaptions (state, payload) {
      state.captions = payload
    },
    setCaptionsEmpty (state, item) {
      const captionIndex = state.captions.findIndex((caption) => caption.diffuseurNomDeCode === item.diffuseurNomDeCode)
      if (captionIndex !== -1) {
        state.captions[captionIndex].text = item.text
      }
    },
    setCaptionOfNetwork (state, { index, caption }) {
      state.captions[index].text = caption.text
      state.captions[index].annonceId = caption.annonceId
      state.captions[index].diffuseurNomDeCode = caption.diffuseurNomDeCode
    },
    setNewCaption (state, newCaption) {
      const diffuseurNomDeCode = newCaption.diffuseurNomDeCode
      const exists = state.captions.some(annonce => annonce.diffuseurNomDeCode === diffuseurNomDeCode)
      if (!exists) {
        state.captions.push(newCaption)
      }
    },
    deleteCaption (state, { diffuseur, annonceId }) {
      // Find index la caption dans le store and delete
      const indexNetwork = state.captions.findIndex((caption) => typeof caption !== 'undefined' && caption.diffuseurNomDeCode === diffuseur && caption.annonceId === annonceId)
      // delete caption
      if (indexNetwork > -1) {
        state.captions.splice(indexNetwork, 1)
      }
    },
    setMessageCaptionUpdated (state, message) {
      state.message = message
      setTimeout(() => {
        state.message = null
      }, 2000)
    }
  }
}
